import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import { Route, Routes } from "react-router";
import { Permission } from "./ProtectRoute/permissionRoutes";
import ScanLoader from "./img/Document scan.gif"
import Studies from "./Pages/EDCManagement/Studies";
import LUPManagement from "./Pages/LUPManagement/LUPManagement";
import PageNotFound from "./Pages/Modules/PageNotFound/PageNotFound";
import CDISCManagement from "./Pages/CDISCMangement/CDISCManagement";
const SharedData = lazy(() => import("./Pages/EDCManagement/DatasetManagement/DatasetsTransfer/SharedData"));
const ChangePassword = lazy(() => import("./Pages/Modules/Auth/UserProfile/changePassword"));
const LoginPage = lazy(() => import("./Pages/Modules/Auth/LoginPage"));
const SharedLoginPage = lazy(() => import("./Pages/Modules/Auth/SharedLoginPage"));
const ForgotPassword = lazy(() => import("./Pages/Modules/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("./Pages/Modules/Auth/ResetPassword"));
const ClientRole = lazy(() => import("./Pages/Roles/ClientRole/ClientRole"));
const UserRole = lazy(() => import("./Pages/Roles/UserRole/UserRole"));
const CTMSManagement = lazy(() => import("./Pages/CTMSManagement/CTMSManagements"));
const ETMFManagement = lazy(() => import("./Pages/ETMFManagement/ETMFManagement"));
const Randomizer = lazy(() => import("./Pages/IWRSMangement/Randomizer"));
const EPROManagement = lazy(() => import("./Pages/EPROManagement/EPROManagement"));
const ICFManagement = lazy(() => import("./Pages/ICFManagement/ICFManagement"));

const App = () => {
  const { LoginPermission, AllPermission, SharedPermission, UserPermission, ClientPermission, CTMSPermission, CDISCPermission, RBQMPermission, EDCPermission, ETMFPermission, EPROPermission, ICFPermission, RandomizePermission, LUPPermission } = Permission;

  const [resizingColumn, setResizingColumn] = useState(null);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const tableRef = useRef(null);

  useEffect(() => {
    const onMouseMove = (e) => {
      if (resizingColumn !== null) {
        const width = startWidth.current + (e.pageX - startX.current);
        const table = tableRef.current;

        if (!table) {
          console.error("Table reference is null.");
          return;
        }

        const th = table.querySelector(`th:nth-child(${resizingColumn + 1})`);

        if (!th) {
          console.error(
            `No th element found for column index: ${resizingColumn}`
          );
          return;
        }

        th.style.width = `${width}px`;
        table.classList.add("resizing");
      }
    };

    const onMouseUp = () => {
      setResizingColumn(null);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    if (resizingColumn !== null) {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [resizingColumn]);

  const onMouseDown = (e, columnIndex) => {
    setResizingColumn(columnIndex);
    startX.current = e.pageX;
    startWidth.current = e.target.offsetWidth;
    document.body.style.userSelect = "none";
    tableRef?.current?.querySelectorAll("th")?.forEach((column, index) => {
      if (index !== columnIndex) {
        column.style.width = `${column.offsetWidth}px`;
      }
    });
  };
  return (
    <>
      <Suspense fallback={<div className="hstack justify-content-center" style={{ height: "100vh" }}><img src={ScanLoader} alt="Loadeer" style={{ height: 200, width: 200 }} /></div>}>
        <Routes>
          <Route path="/" element={<AllPermission />}>
            <Route path="/" element={<LoginPage />} />
          </Route>

          <Route path="/login" element={<LoginPermission />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>

          <Route path="/sharedDataLogin/:studyId/:transferId" element={<LoginPermission />}>
            <Route path="/sharedDataLogin/:studyId/:transferId" element={<SharedLoginPage />} />
          </Route>

          <Route path="/sharedData" element={<SharedPermission />}>
            <Route path="/sharedData" element={<SharedData tableRef={tableRef} onMouseDown={onMouseDown} />} />
          </Route>

          <Route path="/forgotPassword" element={<LoginPermission />}>
            <Route path="/forgotPassword" element={<ForgotPassword />} />
          </Route>

          <Route path="/resetPassword" element={<LoginPermission />}>
            <Route path="/resetPassword" element={<ResetPassword />} />
          </Route>

          <Route path="/changePassword" element={<AllPermission />}>
            <Route path="/changePassword" element={<ChangePassword />} />
          </Route>

          <Route path="/userRole" element={<UserPermission />}>
            <Route path="/userRole" element={<UserRole tableRef={tableRef} onMouseDown={onMouseDown} />} />
          </Route>

          <Route path="/clientRole" element={<ClientPermission />}>
            <Route path="/clientRole" element={<ClientRole tableRef={tableRef} onMouseDown={onMouseDown} />} />
          </Route>

          <Route path="/edc/:studyId" element={<EDCPermission />}>
            <Route path="/edc/:studyId" element={<Studies tableRef={tableRef} onMouseDown={onMouseDown} />} />
          </Route>

          <Route path="/iwrs/:studyId" element={<RandomizePermission />}>
            <Route path="/iwrs/:studyId" element={<Randomizer />} />
          </Route>

          <Route path="/etmf/:studyId" element={<ETMFPermission />}>
            <Route path="/etmf/:studyId" element={<ETMFManagement />} />
          </Route>

          <Route path="/ePro/:studyId" element={<EPROPermission />}>
            <Route path="/ePro/:studyId" element={<EPROManagement />} />
          </Route>

          <Route path="/LUP/:studyId" element={<LUPPermission />}>
            <Route path="/LUP/:studyId" element={<LUPManagement />} />
          </Route>

          <Route path="/icf/:studyId" element={<ICFPermission />}>
            <Route path="/icf/:studyId" element={<ICFManagement />} />
          </Route>

          <Route path="/ctms/:studyId" element={<CTMSPermission />}>
            <Route path="/ctms/:studyId" element={<CTMSManagement />} />
          </Route>

          <Route path="/cdisc/:studyId" element={<CDISCPermission />}>
            <Route path="/cdisc/:studyId" element={<CDISCManagement />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
